import { c as _c } from "react/compiler-runtime";
import { Button } from "@justhome/react-ui";
import { FC, PropsWithChildren } from "react";
const Submit: FC<PropsWithChildren> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Button iconEnd="Right" variant="primary" type="submit" size="md" className="w-fit" data-testid="test-submit">{children}</Button>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default Submit;